import { useCallback, useState, useContext } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import { useDispatch } from 'react-redux'
import { CvsDrawer } from '@components'
import { fieldSetContext } from '@contexts'
import { showSnackbar } from 'functions'
import * as css from './styles'
import { t } from '@lingui/core/macro'

interface Props {
  isOpen: boolean
  onDrawerClose: () => void
}

export const AddFieldsetDrawer = ({ isOpen, onDrawerClose }: Props) => {
  const { saveFieldSet } = useContext(fieldSetContext)
  const dispatch = useDispatch()
  const [name, setName] = useState<string>('')
  const [description, setDescription] = useState<string>('')

  const submitCallback = useCallback(
    _form => {
      try {
        saveFieldSet({
          id: null,
          name,
          description,
          fields: [],
          targets: [],
        })
      } catch {
        dispatch(
          showSnackbar({
            message: 'Failed to save new fieldset.',
            type: 'ERROR',
            duration: 5000,
          }),
        )
      }

      onDrawerClose()

      dispatch(
        showSnackbar({
          message: 'New fieldset saved successfully.',
          type: 'SUCCESS',
          duration: 5000,
        }),
      )
    },
    [name, description],
  )

  return (
    <CvsDrawer title={t`Add new field set`} visible={isOpen} onClose={onDrawerClose}>
      <css.Form>
        <css.FormGroup>
          <TextField
            required
            label={t`Field set name`}
            variant="outlined"
            value={name}
            onChange={e => {
              const { value } = e.target
              setName(value)
            }}
            style={{ minWidth: 230 }}
          />
          <TextField
            label={t`Description`}
            variant="outlined"
            value={description}
            onChange={e => {
              const { value } = e.target
              setDescription(value)
            }}
            style={{ minWidth: 230 }}
          />
        </css.FormGroup>
        <Button variant="contained" color="secondary" type="submit" onClick={submitCallback}>
          {t`Save`}
        </Button>
      </css.Form>
    </CvsDrawer>
  )
}
